import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Stores the logged-in user's data

  const login = (userData) => {
    setUser(userData); // Update user data
    localStorage.setItem("authToken", userData.token); // Save token to localStorage
  };

  const logout = () => {
    setUser(null); // Clear user data
    localStorage.removeItem("authToken"); // Remove token from localStorage
  };

  const isAuthenticated = !!user; // Boolean for authentication status

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);
